import api from "./api";

// Payment report PDF exports.
//
// IMPORTANT: as of this writing, none of these three routes exist on the
// backend yet — checked routes/api.php and every controller under
// app/Http/Controllers/ (no /api/reports/* route, no ReportController at
// all). These calls will 404 until the backend adds matching routes. Wired
// here ahead of time per explicit instruction to prepare the frontend only,
// with no backend changes. Once the backend exists, verify the assumptions
// below against it and correct this file if anything differs:
//   - GET (not POST), query params { format: "pdf", delivery: "attachment" }
//   - Binary PDF response, consumed here as a blob
//   - No dedicated report permission is seeded anywhere in
//     PermissionSeeder.php, so callers gate visibility on the existing
//     "view_payments" permission instead (see PaymentsManagement.jsx)

const exportReport = (resource) =>
  api
    .get(`/api/reports/${resource}/export`, {
      params: { format: "pdf", delivery: "attachment" },
      responseType: "blob",
      headers: { Accept: "application/pdf" },
    })
    .then((r) => r.data);

// GET /api/reports/booking-payments/export?format=pdf&delivery=attachment
export const exportBookingPaymentsReport = () => exportReport("booking-payments");

// GET /api/reports/member-payments/export?format=pdf&delivery=attachment
// Covers member registration AND renewal payments (per the report's name).
export const exportMemberPaymentsReport = () => exportReport("member-payments");

// GET /api/reports/club-payments/export?format=pdf&delivery=attachment
// Covers club registration AND renewal payments (per the report's name).
export const exportClubPaymentsReport = () => exportReport("club-payments");

// ── Payments-by-facility dashboard (PaymentDashboardController) ─────────────
// Unlike the exports above, these two routes are real and verified against
// routes/api.php + PaymentDashboardController — gated by
// "permission:view_reports|view_bookings" (either permission passes).
// Both only ever consider Paid bookings (and, where a "confirmed" booking
// status exists, only confirmed slots) — Pending/Failed/cancelled bookings
// never appear here.

// GET /api/dashboard/bookings/by-facility/totals — optional { date_from,
// date_to } ("Y-m-d"). Returns { filters, total: {booking_count,
// total_slots, paid_amount}, facilities: [{facility_id, facility_name,
// booking_count, total_slots, paid_amount}] } — one row per facility that has
// at least one paid booking in range, sorted by facility_name. No pagination
// (there are only ever a handful of facilities).
export const getFacilityPaymentTotals = (params = {}) =>
  api.get("/api/dashboard/bookings/by-facility/totals", { params }).then((r) => r.data);

// GET /api/dashboard/bookings/by-facility — optional { facility_id,
// date_from, date_to, page, per_page } (per_page capped at 200 server-side).
// Returns { filters, total: {booking_count, total_slots, paid_amount}, rows:
// [{booking_id, payment_id, payment_reference, booking_date, facility_id,
// facility_name, slot_code, start_time, end_time, total_slots, member_id,
// member_code, member_name, member_email, club_id, club_code, club_name,
// paid_amount, paid_at, payment_status}], pagination: {page, per_page,
// total, last_page} } — one row per booking (not per slot), newest first.
export const getFacilityPaymentDetails = (params = {}) =>
  api.get("/api/dashboard/bookings/by-facility", { params }).then((r) => r.data);
